import * as React from 'react';
import { EntityTooltip } from '../entities/entity-tooltip';
export var defaultEntityTypeTooltipsSet = {
  Entity: EntityTooltip
};
export var EntityTypeTooltipsContext = React.createContext(defaultEntityTypeTooltipsSet);
export var EntityTypeTooltipsProvider = EntityTypeTooltipsContext.Provider;